import { render, staticRenderFns } from "./MoneyRecord.vue?vue&type=template&id=662af8a6&scoped=true&"
import script from "./MoneyRecord.vue?vue&type=script&lang=js&"
export * from "./MoneyRecord.vue?vue&type=script&lang=js&"
import style0 from "./MoneyRecord.vue?vue&type=style&index=0&id=662af8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662af8a6",
  null
  
)

export default component.exports